import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import config from '../config';

let userManager = null;

export function initializeAuth() {
  const { serverUrl, realm, clientId } = config.keycloak;
  const authority = `${serverUrl}/realms/${realm}`;

  userManager = new UserManager({
    authority: authority,
    client_id: clientId,
    redirect_uri: window.location.origin + '/callback',
    response_type: 'code',
    scope: 'openid profile email',
    post_logout_redirect_uri: window.location.origin + '/',
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: window.location.origin + '/silent-renew',
  });

  return userManager;
}

export function getUserManager() {
  if (!userManager) {
    initializeAuth();
  }
  return userManager;
}

export async function signIn() {
  const manager = getUserManager();
  await manager.signinRedirect();
}

export async function signOut() {
  const manager = getUserManager();
  await manager.signoutRedirect();
}

export async function getUser() {
  const manager = getUserManager();
  return await manager.getUser();
}

export async function handleCallback() {
  const manager = getUserManager();
  return await manager.signinRedirectCallback();
}

export function getKeycloakUserId(user) {
  // Extract the Keycloak user ID (sub claim) from the OIDC user object
  return user?.profile?.sub || null;
}
